module.exports = __webpack_public_path__ + "static/media/order-ico-02.9f343075.svg";